import { FormDataStep1 } from '@/pages/selling-process';
import { useState } from 'react';
import store from 'store2';

export function useStoreSellFormStep1() {
  const [form, setForm] = useStore<FormDataStep1 & { id?: string }>(
    'form_data_step_1',
    {
      id: '',
      'machine-details_brand': '',
      'machine-details_machine_category': '',
      'machine-details_model': '',
      'machine-details_under_power': '0',
      'machine-details_year': 0,
    }
  );
  return [form, setForm] as const;
}

export default function useStore<T>(key: string, initialValue: T) {
  // State to store our value
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = useState<T>(() => {
    if (typeof window === 'undefined') {
      return initialValue;
    }
    try {
      // Get from local storage by key
      const item = store.get(key);
      // Parse stored json or if none return initialValue
      return item ? JSON.parse(item) : initialValue;
    } catch (error) {
      // If error also return initialValue
      console.log(error);
      return initialValue;
    }
  });
  // Return a wrapped version of useState's setter function that ...
  // ... persists the new value to store.
  const setValue = (value: T | ((val: T) => T)) => {
    try {
      // Allow value to be a function so we have same API as useState
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      // Save state
      setStoredValue(valueToStore);
      // Save to local storage
      if (typeof window !== 'undefined') {
        store.set(key, JSON.stringify(valueToStore));
      }
    } catch (error) {
      // A more advanced implementation would handle the error case
      console.error('useStore error', error);
    }
  };
  return [storedValue, setValue] as const;
}
